function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M0 12.001C0 5.37419 5.37321 0.000976562 12 0.000976562C18.6268 0.000976562 24 5.37419 24 12.001C24 18.6278 18.6268 24.001 12 24.001C5.37321 24.001 0 18.6278 0 12.001ZM2.03571 12.001C2.03571 17.5028 6.49821 21.9653 12 21.9653C17.5018 21.9653 21.9643 17.5028 21.9643 12.001C21.9643 6.49919 17.5018 2.03669 12 2.03669C6.49821 2.03669 2.03571 6.49919 2.03571 12.001ZM11.0905 17.6244C10.8493 17.3833 10.7139 17.0563 10.7139 16.7153C10.7139 16.3743 10.8493 16.0472 11.0905 15.8061C11.3316 15.565 11.6586 15.4295 11.9996 15.4295C12.3406 15.4295 12.6676 15.565 12.9087 15.8061C13.1498 16.0472 13.2853 16.3743 13.2853 16.7153C13.2853 17.0563 13.1498 17.3833 12.9087 17.6244C12.6676 17.8655 12.3406 18.001 11.9996 18.001C11.6586 18.001 11.3316 17.8655 11.0905 17.6244ZM12.6425 13.7153H11.3567C11.2389 13.7153 11.1425 13.6188 11.1425 13.501V6.21526C11.1425 6.0974 11.2389 6.00098 11.3567 6.00098H12.6425C12.7603 6.00098 12.8567 6.0974 12.8567 6.21526V13.501C12.8567 13.6188 12.7603 13.7153 12.6425 13.7153Z",
  fill: "#F3BB1C"
});

function SvgWarning(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWarning);
export default __webpack_public_path__ + "static/media/warning.99b64fe3.svg";
export { ForwardRef as ReactComponent };